module.exports = __webpack_public_path__ + "img/shigongdui@2x.e5664c18.png";